import styled from "styled-components";

import { Link as LinkComponent } from "@components/Navigation/Link";

import { text } from "@ui/helpers";
import { Text } from "@ui/Atoms/Text";

export const Nav = styled.nav`
  padding-top: calc(
    ${props => props.theme.spacing.spacing_16} + var(--drawer-gap)
  );
  display: grid;
  grid-template-columns: min-content 1fr;
  row-gap: ${props => props.theme.spacing.spacing_24};
  column-gap: ${props => props.theme.spacing.spacing_8};

  ${props => props.theme.breakpointsV2.smallTablet} {
    row-gap: ${props => props.theme.spacing.spacing_16};
  }
`;

export const Header = styled(Text)`
  grid-column: 1/3;
`;

export const Link = styled(LinkComponent)`
  grid-column: 1/3;

  &:has(* + span) {
    display: grid;
    align-items: center;
    grid-template-columns: subgrid;
  }
`;

export const CodeBlock = styled.span`
  ${text("regular_12")};

  padding: ${({ theme }) =>
    `${theme.spacing.spacing_8} ${theme.spacing.spacing_16}`};
  font-weight: ${props => props.theme.fontWeights[500]};
  text-align: center;
  text-transform: uppercase;
  border: 1px solid currentColor;
  border-radius: 8px;
  display: inline-block;
  grid-column: 1;

  ${props => props.theme.breakpointsV2.smallDesktop} {
    ${text("medium_14")}
  }
`;
